<template>
  <div id="Rope">
    <div style="position: fixed; bottom: 20vh; left: 50%; transform: translate(-50%, 0);">
      <div style="position: relative;">
        <div style="position: absolute; left: 50%; transform: translate(-50%, 0); z-index: 10;">
          <img :src="RopeImg" style="width: 200vw; height: auto; position: relative; transition: all 0.6s ease;" :style="{ left: getRopePosition + 'vw'}">
        </div>

        <div style="position: absolute; top: 0;">
          <div style="position: absolute; bottom: -3vw; left: 50%; transform: translate(-50%, 0);">
            <img :src="FlagImg" style="width: 5vw; height: auto; position: relative; left: 2vw;">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RopeImg from '@/assets/rope.png'
import FlagImg from '@/assets/flag.png'

export default {
  name: "Rope",
  props: {
    red_score: {
      type: Number,
      default: 0
    },
    white_score: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      RopeImg: RopeImg,
      FlagImg: FlagImg
    }
  },
  computed: {
    getRopePosition() {
      let position = 0
      // NOTE: そのままの計算した値を使うとえげつない数字になるので、割ってます。
      position = (this.white_score - this.red_score) / 100

      return position
    }
  }
}
</script>

<style scoped>

</style>
